import { Select } from '@shared/UI';
import { withSelectField } from '../withSelectField';

export const SelectField = withSelectField(Select);
